import DateText from 'components/inputs/date-text'
import ToolbarContainer_s from 'components/subnav/toolbar-styles'
import DataTable_s from "components/table/data-table-styles"
import styled from "styled-components"
import { Colors } from 'styles/app-styles'
import { InputBaseStyles } from 'styles/input-styles'

export const DateText_s = styled(DateText)`
  ${InputBaseStyles}
  padding: 0 8px;
  outline: none;
  width: 155px;
`

export const FolderSettingsWrapper_s = styled.div`
  ${ToolbarContainer_s}{
    z-index: 4;
  }
  .settings-form {
    background: ${Colors.white};
    position: fixed;
    padding-top: 10px;
    padding-left: 15px;
    z-index: 3;
  }

  .folder-permissions-toolbar {
    border-top: 1px solid ${Colors.towerGrey};
    height: 36px;
    z-index: 2;
  }

  .search-embedded {
    top: 217px;
    z-index: 2;
  }

  #nameInput {
    width: 300px;
  }

  #chart-selector {
    width: 250px;
  }
`

export const FolderSettingsTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  padding-bottom: 0;

  .p-datatable {
    position: absolute;
    top: 200px;
  }

  th.p-filter-column > input {
    width: 100%;
  }

  .p-datatable-scrollable-view {
    thead.p-datatable-thead {
      background: ${Colors.white};
      position: fixed;
      z-index: 1;
    }
  }

  div.p-datatable-scrollable-header {
    padding-top: 0;
  }

  thead.p-datatable-thead {
    align-items: end;
    display: flex;
    height: 40px;
  }

  .p-datatable-scrollable-body {
    padding-bottom: 200px;
    padding-top: 40px;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  tbody.p-datatable-tbody > tr > td:first-child {
    padding-left: 15px;
  }

  tbody.p-datatable-tbody > tr > td {
    padding-left: 5px;
  }

  .p-paginator {
    bottom: 0;
  }
`
